import { Controller } from "stimulus";
import axios from "axios";
import {escapeRegExp, removeAccents} from "../helpers/string"
export default class extends Controller {
  static targets = ["container", "loading", "treatmentRow", "emptyState"];

  connect() {

    this.searchContent = _.throttle(searchTerm => {
      this.loadingTarget.classList.toggle("tw-hidden");
      this.emptyStateTarget.classList.add("tw-hidden");
      searchTerm = searchTerm.trim()
      const searchRegex = new RegExp(escapeRegExp(removeAccents(searchTerm)), 'gi');
      let filteredLength = 0;

      this.treatmentRowTargets.forEach(function(row){
        if (row.querySelector(".treatment-discarded-at-field").value) {
          return
        }
        const treatmentName = removeAccents(row.querySelector(".treatment-input-name").value.trim())
        if (!searchTerm || treatmentName.match(searchRegex)) {
          filteredLength++
          row.classList.remove("tw-hidden")
        } else {
          row.classList.add("tw-hidden")
        }
      })

      if (filteredLength === 0) {
        this.emptyStateTarget.classList.remove("tw-hidden");
        this.emptyStateTarget.children[0].textContent = `Nenhum procedimento foi encontrado para o termo "${searchTerm}".`
      }

      this.loadingTarget.classList.toggle("tw-hidden");
    }, 200);
  }

  search(event) {
    event.preventDefault();
    this.searchContent(event.target.value)
  }
}

